<template>
    <div class="warning">
        <!-- 警告 -->
        <vue-headful :title="$t('warning.labels.login')"/>
        <div><message/></div>
        <div class="mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-3"></div>
                    <div class="col-sm-12 col-md-6 border border-warning">
                        <div class="row mt-2 mb-1">
                            <!-- 不正アクセスです -->
                            <h2 style="color:#a60000;">{{$t('warning.labels.unauthorizedAccess')}}</h2>
                        </div>
                        <!-- トップページより再度購入手続きをお願いいたします。 -->
                        <div class="row mb-1">
                            {{$t('warning.labels.msg1')}}
                        </div>
                        <div class="row mb-1">
                            <!-- トップページへ戻る -->
                            <a href @click="gotoTop()">{{$t('common.buttons.backToTopPage')}}</a>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SiteConstants from 'assets/const/SiteConstants.json';

export default {
    name: "Warning",
    data() {
        return {
            SiteConstants: SiteConstants,
            site: ""
        }
    },
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
    },
    methods: {
       gotoTop: function(){
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query: {pageNo: 1}});
       }
    }
}
</script>